import React from "react";
import { useNavigate } from "react-router-dom";

const POSTERS = [
  {
    id: "mekanikerchat",
    name: "Mekanikerchat",
    description: "A4-plakat til verkstedbenken – QR-koder for booking, «Spør mekaniker» og akuttservice.",
    icon: "🔧",
  },
  {
    id: "prisliste-sykkel",
    name: "Prisliste sykkelservice",
    description: "Banner 297×700mm – servicepakker og enkeltservicer, hentet live fra tjenestekatalogen.",
    icon: "💰",
  },
];

function PosterCard({ poster, onOpen }) {
  return (
    <div
      onClick={() => onOpen(poster.id)}
      className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md hover:border-indigo-300 transition-all cursor-pointer flex flex-col gap-3"
    >
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded border border-gray-100 bg-gray-50 flex items-center justify-center text-2xl shrink-0">
          {poster.icon}
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 truncate">{poster.name}</p>
          <p className="text-xs text-gray-500">A4 · utskriftsklar</p>
        </div>
      </div>
      <p className="text-sm text-gray-500">{poster.description}</p>
    </div>
  );
}

function Plakater() {
  const navigate = useNavigate();

  return (
    <div className="max-w-5xl mx-auto py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Plakater</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Utskriftsvennlige A4-plakatmaler til butikk og verksted.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {POSTERS.map((poster) => (
          <PosterCard key={poster.id} poster={poster} onOpen={(id) => navigate(`/plakater/${id}`)} />
        ))}
      </div>
    </div>
  );
}

export default Plakater;
